module.exports = __webpack_public_path__ + "media/images/calendar/february-435af0a00650acb60bce40f39fc88f02.jpg";